export const TimeSerieFilesStatus = {
  PENDING: "pending",
  EXTRACTED: "extracted",
  TRANSFORMED: "transformed",
  LOADED: "loaded",
  COMPUTED: "computed",
  ERROR: "error",
  IGNORED: "ignored",
  PREPROCESSED: "preprocessed",
} as const;

export type TimeSerieFilesStatus =
  (typeof TimeSerieFilesStatus)[keyof typeof TimeSerieFilesStatus];

export const labelByTimeSerieFileStatus = (
  value: TimeSerieFilesStatus,
  t: (key: string) => string,
) => {
  const map: Record<TimeSerieFilesStatus, string> = {
    [TimeSerieFilesStatus.PENDING]: t("badge.pending"),
    [TimeSerieFilesStatus.EXTRACTED]: t("badge.pending"),
    [TimeSerieFilesStatus.TRANSFORMED]: t("badge.pending"),
    [TimeSerieFilesStatus.LOADED]: t("badge.validated"),
    [TimeSerieFilesStatus.COMPUTED]: t("badge.validated"),
    [TimeSerieFilesStatus.ERROR]: t("badge.error"),
    [TimeSerieFilesStatus.IGNORED]: t("badge.ignored"),
    [TimeSerieFilesStatus.PREPROCESSED]: t("badge.pending"),
  };
  return map[value];
};
